import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {ShopCreature} from "@/store/shop/types";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import SpriteUtils from "@/utils/sprite-utils";

export class CreatureDescPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, sc: ShopCreature) {
        super(scene, canvas, Tr('nagrada'));
        this.setDepth(20000);
        this.background.setAlpha(0.01);

        let creature = sc.creature;

        let mainText = TextUtils.addTextByFamily(scene, Tr('hero.for.the.quest') + creature.name.toUpperCase() + Tr('cost') + TextUtils.formatGems(sc.oldPrice) + Tr('emeralds'),
            0, -150, '#ffc536', 17, 'normal', 380, Fonts.BENGALY_NORMAL);

        let light = SpriteUtils.addSprite(this.scene!, 0, -80, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 4, 2);

        let creaturePanel: CreaturePanel = new CreaturePanel(scene, 0, 0, creature, () => {}, true, true);

        let okButton = new SquareButton(this.scene, 0, 150, 0,
            Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('otlichno').toUpperCase(), false);

        let self = this;
        okButton.setCallback(() => {
            if (this.isOnTop()) {
                self.close();
            }
        });

        this.add([light, mainText, creaturePanel, okButton]);
    }

}
